import { trackers } from "@/common/functions/trackingUtils";

export const TRACKER_DATA = trackers();

export const TRACKER_SETTINGS = {
	[TRACKER_DATA.YD]: { sampleRate: 1 },
	[TRACKER_DATA.WF]: { sampleRate: 5 },
};
